import { useEffect, useState } from "react";
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { Field, buildPayload } from "./Field";

export const RecordForm = ({ open, onClose, schema, record, onSave }) => {
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);
  useEffect(() => { setForm(record || {}); }, [record, open]);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async () => {
    setSaving(true);
    await onSave(buildPayload(schema.fields, form));
    setSaving(false);
  };

  return (
    <Sheet open={open} onOpenChange={(o) => !o && onClose()}>
      <SheetContent className="glass-strong border-white/10 w-full sm:max-w-lg overflow-y-auto" data-testid="record-form">
        <SheetHeader><SheetTitle className="font-serif text-2xl text-white">{record?.id ? `Edit ${schema.singular}` : `New ${schema.singular}`}</SheetTitle>
          <SheetDescription className="sr-only">Fill in the fields and save.</SheetDescription>
        </SheetHeader>
        <div className="mt-6 space-y-4 pb-24">
          {schema.fields.map((f) => (
            <div key={f.key}>
              <label className="text-[11px] font-mono uppercase tracking-widest text-slate-400 mb-1.5 block">
                {f.label}{f.required && <span className="text-rose-400"> *</span>}
              </label>
              <Field f={f} value={form[f.key]} onChange={(v) => set(f.key, v)} />
            </div>
          ))}
        </div>
        <div className="sticky bottom-0 -mx-6 px-6 py-4 bg-black/70 backdrop-blur border-t border-white/10 flex gap-3">
          <Button onClick={submit} disabled={saving} className="btn-primary rounded-lg flex-1" data-testid="record-save-btn">{saving ? "Saving…" : "Save"}</Button>
          <Button variant="outline" onClick={onClose} data-testid="record-cancel-btn">Cancel</Button>
        </div>
      </SheetContent>
    </Sheet>
  );
};
